import React from 'react';
import DateTime from 'utils/date-time';
import IconButton from 'components/buttons/icon-button/IconButton';
import NavigationChevronLeft from 'components/svg-icons/navigation-chevron-left';
import NavigationChevronRight from 'components/svg-icons/navigation-chevron-right';
import Transition from 'components/transition-groups/Transition';

export default React.createClass({

	propTypes: {
		displayDate: React.PropTypes.object.isRequired,
		onLeftTouchTap: React.PropTypes.func,
		onRightTouchTap: React.PropTypes.func,
		maxDate: React.PropTypes.object,
		minDate: React.PropTypes.object
	},

	getInitialState() {
		return {
			transitionDirection: 'up'
		};
	},
	
	getDefaultProps: function () {
		return {
			maxDate: null,
			minDate: null
		};
	},
	
	_isDisabled: function(direction){
	
		let date = this.props.displayDate;
		let minDate = this.props.minDate;
		let maxDate = this.props.maxDate;

		if(direction == "left" && minDate){      
			if(date.year() < minDate.year()) return true;
			if(date.year() == minDate.year()){
				return date.month() <= minDate.month();
			}
		} else if (direction == "right" && maxDate){
			if(date.year() > maxDate.year()) return true;
			if(date.year() == maxDate.year()){
				return date.month() >= maxDate.month();
			}
		}

		return false;
	},

	componentWillReceiveProps(nextProps) {
		let direction;

		if (nextProps.displayDate !== this.props.displayDate) {
			direction = nextProps.displayDate > this.props.displayDate ? 'up' : 'down';
			this.setState({
				transitionDirection: direction
			});
		}
	},

	render() {
		let month = this.props.displayDate.format("MMMM"),
			year = this.props.displayDate.year(),
			disableLeft = this._isDisabled("left"),
    		disableRight = this._isDisabled("right");

		return (
			<div className="lui-date-picker-calendar-toolbar">

				<Transition
					className="lui-date-picker-calendar-toolbar-title"
					direction={this.state.transitionDirection}>
					<div key={month + '_' + year}>{month} {year}</div>
				</Transition>

				<IconButton
					disabled={disableLeft}
					className="lui-date-picker-calendar-toolbar-button-left"
					onClick={this.props.onLeftTouchTap}>
						<NavigationChevronLeft/>
				</IconButton>

				<IconButton
					disabled={disableRight}
					className="lui-date-picker-calendar-toolbar-button-right"
					onClick={this.props.onRightTouchTap}>
						<NavigationChevronRight/>
				</IconButton>

			</div>
		);
	}
});


/** WEBPACK FOOTER **
 ** ./src/components/date-picker/CalendarToolbar.js
 **/